module.exports = __webpack_public_path__ + "media/images/gallery/constellations/star_layer_on-6294d806c889ecc81fafda66e9e44133.jpg";